
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Header from '../Components/Header'
import Feed from '../Components/Organizer/Feed'
import Membergrp from '../Components/Organizer/Membergrp'
import Album from '../Components/Organizer/Album'
import Sendinvites from '../Components/Organizer/Sendinvites'
import Manage from '../Components/Organizer/Manage'
import Photo from '../Components/Organizer/Photo'
import { Button } from 'react-bootstrap'

const CreateGroupPage2 = () => {
  const { id } = useParams()
  const [activeTab, setActiveTab] = useState('Members')
  const [groupData, setGroupData] = useState(null)
  const [loading, setLoading] = useState(true)
  const token = localStorage.getItem('jwttoken')
  const backendURL = 'https://kaasbackend.vetrinahealthcare.com'

  useEffect(() => {
    const fetchGroupDetails = async () => {
      try {
        const response = await axios.get(
          `${backendURL}/socialapp/groups/${id}/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        setGroupData(response.data)
      } catch (error) {
        console.error('Error fetching group data:', error)
      } finally {
        setLoading(false)
      }
    }

    if (id) {
      fetchGroupDetails()
    }
  }, [id])

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Members':
        return <Membergrp members={groupData?.members || []} />
      case 'Feed':
        return <Feed />
      case 'Photo':
        return <Photo />
      // case "Albums":
      //   return <Album />;
      case 'Send Invites':
        return <Sendinvites />
      case 'Manage':
        return <Manage />
      default:
        return <Membergrp />
    }
  }

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <div className='spinner-border text-primary'></div>
      </div>
    )
  }

  if (!groupData) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px', color: 'red' }}>
        <p>Failed to load group data.</p>
      </div>
    )
  }

  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <Header />
      <div className='container 'style={{marginTop:"5.5rem"}}>
        <div className='card shadow border-0'>
          {/* Group Cover */}
          <div
            style={{
              height: '220px',
              backgroundImage: `url(${
                groupData.cover_photo
                  ? `${backendURL}/lms/media/group_covers/${groupData.cover_photo
                      .split('/')
                      .pop()}`
                  : 'https://placehold.co/900x220?text=Group+Cover'
              })`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '10px 10px 0 0',
              position: 'relative',
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '10px 10px 0 0',
              }}
            ></div>

            {/* Camera Icon */}
            <div
              style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                backgroundColor: '#fff',
                borderRadius: '50%',
                padding: '5px',
                cursor: 'pointer',
              }}
            >
              <i className='bi bi-camera'></i>
            </div>
          </div>

          {/* Group Header */}
          <div
            style={{
              backgroundColor: '#fff',
              display: 'flex',
              alignItems: 'center',
              padding: '20px',
              borderRadius: '0 0 10px 10px',
              boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
              position: 'relative',
            }}
          >
            {/* Group Avatar */}
            <div
              style={{
                width: '100px',
                height: '100px',
                backgroundImage: `url(${
                  groupData.group_image
                    ? `${backendURL}/lms/media/group_images/${groupData.group_image
                        .split('/')
                        .pop()}`
                    : 'https://placehold.co/100x100?text=Group'
                })`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '10px',
                border: '3px solid white',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                position: 'absolute',
                top: '-50px',
                left: '20px',
              }}
            ></div>

            {/* Group Info */}
            <div style={{ marginLeft: '120px', flex: 1 }}>
              <h3 style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                {groupData.name}
              </h3>

              {/* Group Type */}
              <span
                style={{
                  background: ' #B8529E',

                  color: 'white',
                  padding: '5px 10px',
                  borderRadius: '10px',
                  fontSize: '12px',
                  fontWeight: '500',
                  display: 'inline-block',
                  marginBottom: '10px',
                }}
              >
                Group
              </span>

              {/* Privacy & Active Status */}
              <p
                style={{ color: '#6c757d', fontSize: '14px', marginTop: '5px' }}
              >
                <i className='bi bi-globe'></i> {groupData.privacy} • Active 6
                hours ago
              </p>

              {/* Organizer Info */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  color: '#6c757d',
                  fontSize: '14px',
                }}
              >
                <strong>Organizer:</strong>
                <i
                  className='bi bi-person-circle'
                  style={{ fontSize: '16px' }}
                ></i>
                <span>{groupData.created_by?.first_name} {groupData.created_by?.last_name}</span>
              </div>
            </div>

            {/* Buttons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Button
                variant='light'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  fontWeight: '500',
                  background: ' #B8529E',
                  color: 'white',
                }}
              >
                <i className='bi bi-person-fill'></i> Organizer
              </Button>

              <Button variant='light'>
                <i className='bi bi-bell-fill'></i>
              </Button>
            </div>
          </div>

          {/* Tabs - Scrollable on Mobile */}
          <div
            style={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              backgroundColor: '#fff',
              boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, 0.1)',
              padding: '8px 0',
              borderRadius: '10px',
            }}
          >
            <ul
              className='nav nav-pills justify-content-center'
              style={{ display: 'flex', gap: '10px', padding: '0 10px' }}
            >
              {['Members', 'Feed', 'Photo', 'Send Invites', 'Manage'].map(
                (tab) => (
                  <li className='nav-item' key={tab}>
                    <button
                      className={`nav-link ${
                        activeTab === tab ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab(tab)}
                      style={{
                        color: activeTab === tab ? 'white' : '#555',
                        backgroundColor:
                          activeTab === tab ? ' #B8529E' : 'transparent',
                        borderRadius: '20px',
                        padding: '8px 12px',
                        transition: '0.3s',
                      }}
                    >
                      {tab}
                    </button>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        {/* Tab Content */}
        <div
          style={{
            padding: '20px',
            backgroundColor: '#fff',
            borderRadius: '10px',
            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
            marginTop: '20px',
          }}
        >
          {renderTabContent()}
        </div>
      </div>
    </div>
  )
}

export default CreateGroupPage2